import styles from "./packages-gallery.module.css";

interface PackagePriceProps {
  price: number;
}

/**
 * "From $X" price for a package card. Renders nothing unless `price` is a
 * positive number, so packages with no rate (0 / null / undefined) simply omit
 * it. Shared by the list and grid cards so the price reads the same in both.
 */
export default function PackagePrice({ price }: PackagePriceProps) {
  if (!(price > 0)) return null;

  return (
    <p className={styles.price}>
      <span className={styles.priceLabel}>From</span>
      <span className={styles.priceValue}>${price.toLocaleString()}</span>
    </p>
  );
}
